module.exports = __webpack_public_path__ + "static/media/mt_folder.6d3a023d.png";